import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { Analytics } from "@faro-lotv/foreign-observers";

export function useManualPageViewTracking(): void {
  const location = useLocation();
  const pageCounterRef = useRef(0);

  useEffect(() => {
    pageCounterRef.current += 1;

    // Manually sending page view tracking to avoid including the document title,
    // which may contain sensitive information (e.g., project name).
    // We disable default tracking and send a custom event without the title.
    /* eslint-disable @typescript-eslint/naming-convention */
    Analytics.track("[Amplitude] Page Viewed", {
      "[Amplitude] Page Domain": window.location.hostname,
      "[Amplitude] Page Path": window.location.pathname,
      "[Amplitude] Page Location": window.location.href,
      "[Amplitude] Page URL": window.location.origin + window.location.pathname,
      "[Amplitude] Page Counter": pageCounterRef.current,
      "[Amplitude] Page Title": "Sphere XG",
    });
    /* eslint-enable @typescript-eslint/naming-convention */
  }, [location.pathname]);
}
